import { io } from "socket.io-client";
import { getAccessToken } from "auth/token";

const SERVER = process.env.REACT_APP_BASE_URL;

const createSocket = () => {
  const token = getAccessToken();

  const socket = io(SERVER, {
    transports: ["websocket", "polling"],
    auth: {
      token: token,
    },
    reconnectionAttempts: 5,
    reconnectionDelay: 3000,
    timeout: 20000,
    autoConnect: false,
  });

  // Handle connection events
  socket.on("connect", () => {
    console.log("Socket connected:", socket.id);
  });

  socket.on("unread_count_update", (count) => {
    console.log("UnREAD", count);
  });

  socket.on("disconnect", (reason) => {
    console.log("Socket disconnected:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error);
  });

  socket.on("join_room", (msg) => {
    console.log("join", msg);
  });

  socket.on("new_message", (new_message) => {
    console.log("New message:", new_message);
  });

  return socket;
};

const socket = createSocket();

export const connectSocket = () => {
  if (!socket.connected) socket.connect();
};

// Call on logout
export const disconnectSocket = () => {
  if (socket.connected) socket.disconnect();
};

export default socket;
